import { useState } from "react";

export interface ILeiaMaisProps {
    children: string;
    charLimit: number;
    customLeiaMais?: React.ReactChild;
    customLeiaMenos?: React.ReactChild;
    disabled?: boolean;
}

export default function LeiaMais(props: ILeiaMaisProps) {
    const [mostrarTudo, setMostrarTudo] = useState(false);

    const spanClassName = `text-${
        props.disabled ? "muted" : "primary"
    } ml-1 btn p-0`;
    const spanOnclick = () => {
        if (!props.disabled) setMostrarTudo(!mostrarTudo);
    };
    const text = mostrarTudo
        ? props.children
        : props.children?.substring(0, props.charLimit) + "...";

    return (
        <>
            {(props.children?.length ?? 0) < props.charLimit ? (
                props.children
            ) : (
                <>
                    {text}
                    <span className={spanClassName} onClick={spanOnclick}>
                        {mostrarTudo
                            ? props.customLeiaMenos ?? "Mostrar Menos"
                            : props.customLeiaMais ?? "Leia Mais"}
                    </span>
                </>
            )}
        </>
    );
}
